const IP_OCTET_REGEX = '(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)'
const IP_REGEX = `^(?:${IP_OCTET_REGEX}\\.){3}${IP_OCTET_REGEX}$`

export const isIPValid = (ip: string): boolean => {
  return new RegExp(IP_REGEX).test(ip)
}

export const isIPRangeValid = (ip: string): boolean => {
  return new RegExp(`${IP_REGEX.slice(0, -1)}\\/(?:2[4-9]|3[0-2])$`).test(ip)
}
